import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

export const statusContainer = style({
  display: 'flex',
  marginTop: TabStyles.Spacing.MediumSpace,
  '$nest': {
    '& > div:first-child': {
      flexShrink: 0,
      marginRight: TabStyles.Spacing.LargeSpace
    }
  }
});